import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  buttonsWrap: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > button': {
      marginRight: 5,
      marginBottom: 5,
    },
  },
}));

const ChartButtonWrap = ({ children }) => {
  const classes = useStyles();

  return <div className={classes.buttonsWrap}>{children}</div>;
};

export default ChartButtonWrap;
